<template>
  <div class="px-6 md:px-12">
    <create-new-folder
      :data-to-show="isCreateFolderPopupDisplayed"
      :errors="errorsCreateNewFolder"
      @showChange="
        (val) => {
          displayPopupAddNewFolder(val);
        }
      "
      @createNewFolder="
        (folder) => {
          createFolder(folder);
        }
      "
      :parent-folder="parentFolder"
    />

    <edit-folder
      :data-to-show="isEditFolderPopupDisplayed"
      :errors="errorsEditFolder"
      :folder="folderToEdit"
      @showChange="
        (val) => {
          displayPopupEditFolder(val);
        }
      "
      @editFolder="
        (folderEdited) => {
          editFolder(folderEdited);
        }
      "
    />

    <delete-folder
      :data-to-show="isDeleteFolderPopupDisplayed"
      :errors="errorsDeleteFolder"
      :folder="folderToDelete"
      @close="displayPopupDeleteFolder(false)"
      @deleteFolder="deleteFolder()"
    />

    <move-folder
      :data-to-show="isMoveFilePopupDisplayed"
      :file-to-move="fileToMove"
      :errors="errorsMoveFile"
      @showChange="
        (val) => {
          displayPopupMoveFile(val);
        }
      "
      @moveFile="
        (file) => {
          moveFile(file);
        }
      "
    />

    <add-member
      :data-to-show="isAddMemberPopupDisplayed"
      :folder="folderToShare"
      :errors="errorsAddMemberFolder"
      @showChange="
        (val) => {
          displayPopupAddMember(val);
        }
      "
      @addMembers="
        (members) => {
          addMembers(members);
        }
      "
      @editUserRights="
        (user, newRights) => {
          editUserRights(user, newRights);
        }
      "
      @editRoleRights="
        (role, newRights) => {
          editRoleRights(role, newRights);
        }
      "
      @revokeUserRights="
        (user) => {
          revokeUserRights(user);
        }
      "
      @revokeRoleRights="
        (role) => {
          revokeRoleRights(role);
        }
      "
    />

    <add-new-file
      :data-to-show="stateAddFilePopup"
      @showChange="
        (val) => {
          changeStatePopupAddNewFile(val);
        }
      "
      :loading="addNewFileLoading"
      @addTempFile="
        (data) => {
          addTempFile(data);
        }
      "
      @addFile="
        (infos) => {
          addFile(infos);
        }
      "
      :file-temp="fileTemp"
      :errors="errorsAddNewFile"
      :current-folder="path.length > 0 ? path[path.length - 1].id : null"
    />

    <edit-file
      :data-to-show="isEditFilePopupDisplayed"
      :errors="errorsEditFile"
      :file="fileToEdit"
      @showChange="
        (val) => {
          displayPopupEditFile(val);
        }
      "
      @editFile="
        (fileEdited) => {
          editFile(fileEdited);
        }
      "
    />

    <preview-file
      :data-to-show="isPreviewPopupDisplayed"
      @close="displayPopupPreview(false)"
      :file="fileToDisplay"
    />

    <div>
      <div v-if="isRootPage" class="flex">
        <h4 class="text-indigo-600 text-left">Dossiers récents</h4>
        <div class="flex-grow" />
        <div v-if="folders.length > 0">
          <h5
            class="text-gray-900 text-right cursor-pointer"
            @click="openFolder()"
          >
            Voir tout
          </h5>
        </div>
      </div>

      <div v-if="isCurrentFolderPage || isRecentFilesPage" class="flex">
        <h4 class="text-left">
          <span class="text-indigo-600 cursor-pointer" @click="goToPath()">
            {{
              isCurrentFolderPage &&
              path.length == 1 &&
              Object.keys(path[0]).length == 0
                ? 'Tous les dossiers'
                : isCurrentFolderPage
                ? 'Dossiers'
                : isRecentFilesPage && files.length > 0
                ? 'Tous les fichiers'
                : ''
            }}
          </span>
          <span
            v-for="(p, i) in path.filter(
              (p) => Object.keys(p).length > 0 && !isRecentFilesPage
            )"
            :key="i"
            @click="goToPath(i)"
            class="text-gray-600 cursor-pointer"
          >
            > {{ p.name }}</span
          >
        </h4>
      </div>

      <div class="relative w-max">
        <div class="my-10">
          <add-button
            v-if="
              (isRootPage && canEdit && $can('documents_create')) ||
              (isCurrentFolderPage &&
                Object.keys(path[path.length - 1]).length == 0) ||
              $editFile(path[path.length - 1], currentPage)
            "
            :libelle="
              'Ajouter un nouveau ' +
              (isRootPage
                ? 'dossier'
                : isCurrentFolderPage
                ? 'dossier ou fichier'
                : isRecentFilesPage
                ? 'fichier'
                : '')
            "
            :with-dropdown="isCurrentFolderPage"
            @add="addButtonDisplaySomething"
          />
        </div>

        <div
          v-if="isDropdownCreateFolderOrFileDisplay"
          class="absolute z-10 right-0 top-8 px-5 py-3 bg-white shadow rounded-xl text-sm"
          v-click-outside="displayDropdownAddNewFolderOrFile"
        >
          <div class="flex flex-col space-y-1.5 text-gray-600">
            <p
              class="hover:text-gray-900 cursor-pointer"
              @click.stop="displayPopupAddNewFolder(true)"
            >
              Nouveau dossier
            </p>
            <p
              class="hover:text-gray-900 cursor-pointer"
              @click.stop="changeStatePopupAddNewFile(1)"
            >
              Nouveau fichier
            </p>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-3 gap-12 mb-12">
        <div
          v-for="(folder, numFolder) in listFolders.filter(
            (f, i) => (i < 3 || isCurrentFolderPage) && !isRecentFilesPage
          )"
          :key="numFolder"
          class="col-span-full md:col-span-1"
        >
          <folder-card
            :editable="$editFile(folder, currentPage) && canEdit"
            :is-admin="$adminFile(folder, currentPage)"
            :is-owner="$ownerFile(folder, currentPage)"
            :folder="folder"
            :folders="folders"
            :files="files"
            :in-neopass-form="currentPage.includes('/form/neopass/')"
            :smaller="currentPage.includes('/form/neopass/')"
            @openFolder="openFolder(folder)"
            @editFolder="displayPopupEditFolder(true, folder)"
            @downloadFolder="downloadAFolder(folder)"
            @deleteFolder="displayPopupDeleteFolder(true, folder)"
            @moveFolder="displayPopupMoveFile(true, folder)"
            @addMember="displayPopupAddMember(true, folder)"
          />
        </div>
      </div>

      <div v-if="isRootPage">
        <div v-if="files.length > 0" class="flex my-10">
          <h4 class="text-indigo-600 text-left">Fichiers récents</h4>
          <div class="flex-grow" />
          <h5
            class="text-gray-900 text-right cursor-pointer"
            @click="displayAllFiles()"
          >
            Voir tout
          </h5>
        </div>
        <add-button
          v-if="canEdit && $can('documents_create')"
          libelle="Ajouter un nouveau fichier"
          @add="changeStatePopupAddNewFile(1)"
        />
      </div>
    </div>

    <div v-if="files.length > 0 && (isRootPage || isRecentFilesPage)">
      <div
        class="grid grid-cols-12 gap-x-4 h-16 lg:h-24 2xl:h-32 text-gray-600 text-lg items-center"
      >
        <div class="col-span-2 justify-self-center">Type</div>
        <div class="col-span-10 md:col-span-2">Nom du fichier</div>
        <div class="md:col-span-2 md:block hidden">Dossier parent</div>
        <div class="md:col-span-2 md:block hidden justify-self-center">
          Membres
        </div>
        <div class="md:col-span-2 md:block hidden">Date création</div>
        <div class="col-span-2 md:block hidden justify-self-center">Plus</div>
      </div>
      <div
        v-for="(file, numFile) in files.filter(
          (f, i) => i < 5 || isRecentFilesPage
        )"
        :key="numFile"
        class="grid grid-cols-12 gap-x-4 h-16 lg:h-24 2xl:h-32 text-base items-center odd:bg-gray-300 odd:bg-opacity-50"
      >
        <div class="col-span-2 justify-self-center">
          <tag
            responsive
            :libelle="file.type.toUpperCase()"
            :theme-color="
              colorByType[file.type.toLowerCase()]
                ? colorByType[file.type.toLowerCase()]
                : 'default'
            "
          />
        </div>
        <div class="col-span-8 md:col-span-2">
          <info-bulle-hover
            :name="'filename' + file.id"
            :libelle="file.name.substring(0, file.name.lastIndexOf('.'))"
            :is-display-tooltip="isFilenameTooltipDisplay == file.id"
            position="bottom-3 left-0"
          />
          <div
            class="truncate"
            @mouseover="isFilenameTooltipDisplay = file.id"
            @mouseleave="isFilenameTooltipDisplay = -1"
          >
            {{ file.name.substring(0, file.name.lastIndexOf('.')) }}
          </div>
        </div>
        <div class="col-span-2 md:block hidden">
          <info-bulle-hover
            :name="'parent' + file.id"
            :libelle="
              file.folder_id == null
                ? 'Mon dépôt de documents'
                : folders.filter((f) => f.id == file.folder_id).length > 0
                ? folders.filter((f) => f.id == file.folder_id)[0].name
                : 'Mon dépôt de documents'
            "
            :is-display-tooltip="isParentFolderNameTooltipDisplay == file.id"
            position="bottom-3 left-0"
          />
          <div
            class="truncate"
            @mouseover="isParentFolderNameTooltipDisplay = file.id"
            @mouseleave="isParentFolderNameTooltipDisplay = -1"
          >
            {{
              file.folder_id == null
                ? 'Mon dépôt de documents'
                : folders.filter((f) => f.id == file.folder_id).length > 0
                ? folders.filter((f) => f.id == file.folder_id)[0].name
                : 'Mon dépôt de documents'
            }}
          </div>
        </div>
        <list-avatars
          class="col-span-2 md:block hidden justify-self-center bottom-1/6"
          :list-items="file.users"
          libelle-firstname="firstname"
          libelle-lastname="lastname"
        />
        <div class="col-span-2 md:block hidden">
          {{ new Date(file.created_at).toLocaleDateString() }}
        </div>
        <div class="col-span-2 justify-self-center">
          <div
            @click.stop="displaySubMenuFile(file.id)"
            class="cursor-pointer p-5 relative"
          >
            <icon name="more-vertical" class="text-pink-600" />
            <div
              v-if="subMenuFileNumber == file.id"
              v-click-outside="hideSubMenuFile"
              class="absolute rounded-md bg-white shadow-lg shadow-gray-600 p-5 right-0 z-30"
            >
              <div class="flex flex-col space-y-2">
                <div
                  v-if="
                    constants.FILE_TYPES.img.includes(
                      file.type.toLowerCase()
                    ) ||
                    constants.FILE_TYPES.pdf.includes(file.type.toLowerCase())
                  "
                  @click="displayPopupPreview(true, file)"
                  class="cursor-pointer text-gray-600 hover:text-gray-900"
                >
                  Visualiser
                </div>
                <div
                  v-if="canEdit && $can('documents_move')"
                  @click="displayPopupMoveFile(true, file)"
                  class="cursor-pointer text-gray-600 hover:text-gray-900"
                >
                  Déplacer
                </div>
                <div
                  v-if="
                    $adminFile(file, currentPage) &&
                    $can('documents_share') &&
                    !$freeParticulier()
                  "
                  @click="displayPopupAddMember(true, file)"
                  class="cursor-pointer text-gray-600 hover:text-gray-900"
                >
                  Partager
                </div>
                <div
                  @click="downloadAFile(file)"
                  class="cursor-pointer text-gray-600 hover:text-gray-900"
                >
                  Télécharger
                </div>
                <div
                  v-if="
                    $editFile(file, currentPage) &&
                    $can('documents_edit_folder')
                  "
                  @click="displayPopupEditFile(true, file)"
                  class="cursor-pointer text-gray-600 hover:text-gray-900"
                >
                  Éditer
                </div>
                <div
                  v-if="
                    $editFile(file, currentPage) && $can('documents_delete')
                  "
                  @click="displayPopupDeleteFolder(true, file)"
                  class="cursor-pointer text-gray-600 hover:text-gray-900"
                >
                  Supprimer
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isCurrentFolderPage" class="grid grid-cols-3 gap-12">
      <div
        v-for="(file, numFile) in currentFiles"
        :key="numFile"
        class="col-span-full md:col-span-1"
      >
        <file-card
          :file="file"
          @openFile="displayPopupPreview(true, file)"
          @downloadFile="downloadAFile(file)"
          @moveFile="displayPopupMoveFile(true, file)"
          @addMember="displayPopupAddMember(true, file)"
          @editFile="displayPopupEditFile(true, file)"
          @deleteFile="displayPopupDeleteFolder(true, file)"
          :editable="$editFile(file, currentPage) && canEdit"
          :is-admin="$adminFile(file, currentPage)"
          :is-owner="$ownerFile(file, currentPage)"
          :in-neopass-form="currentPage.includes('/form/neopass/')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import AddButton from './../../components/Inputs/AddButton';
import FolderCard from './../../components/DepotDocuments/FolderCard';
import FileCard from './../../components/DepotDocuments/FileCard.vue';
import Tag from './../../components/Tag';
import ListAvatars from './../../components/ListAvatars';
import Icon from './../../components/Icon';
import InfoBulleHover from './../../components/InfoBulleHover';

import CreateNewFolder from './popup/CreateNewFolder.vue';
import EditFolder from './popup/EditFolder.vue';
import DeleteFolder from './popup/DeleteFolder.vue';
import MoveFolder from './popup/MoveFolder.vue';
import AddMember from './popup/AddMember';
import AddNewFile from './popup/AddNewFile.vue';
import PreviewFile from './popup/PreviewFile.vue';
import EditFile from './popup/EditFile.vue';

import Constants from './../../constants';
import ClickOutside from 'vue-click-outside';
import JsFileDownload from 'js-file-download';

export default {
  name: 'FilesList',

  components: {
    AddButton,
    FolderCard,
    FileCard,
    Tag,
    ListAvatars,
    Icon,
    CreateNewFolder,
    EditFolder,
    DeleteFolder,
    MoveFolder,
    AddMember,
    AddNewFile,
    JsFileDownload,
    InfoBulleHover,
    PreviewFile,
    EditFile,
  },

  props: {
    folders: {
      type: Array,
      required: true,
    },

    files: {
      type: Array,
      required: true,
    },

    colorByType: {
      type: Object,
    },

    path: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      subMenuFileNumber: -1,

      isDropdownCreateFolderOrFileDisplay: false,

      isCreateFolderPopupDisplayed: false,
      errorsCreateNewFolder: {},

      isEditFolderPopupDisplayed: false,
      folderToEdit: {},
      errorsEditFolder: {},

      isDeleteFolderPopupDisplayed: false,
      folderToDelete: {},
      errorsDeleteFolder: {},

      isMoveFilePopupDisplayed: false,
      errorsMoveFile: {},
      fileToMove: {},

      isAddMemberPopupDisplayed: false,
      folderToShare: {},
      errorsAddMemberFolder: {},

      stateAddFilePopup: -1,
      fileTemp: {
        id: null,
        path: '',
        finalPath: '',
        name: '',
      },
      errorsAddNewFile: {},
      addNewFileLoading: false,

      isPreviewPopupDisplayed: false,
      fileToDisplay: {},

      isEditFilePopupDisplayed: false,
      errorsEditFile: {},
      fileToEdit: {},

      constants: Constants,

      isFilenameTooltipDisplay: -1,
      isParentFolderNameTooltipDisplay: -1,
    };
  },

  mounted() {
    //
  },

  methods: {
    ...mapActions({
      createNewFolder: 'depotDocuments/createNewFolder',
      editCurrentFolder: 'depotDocuments/editCurrentFolder',
      deleteCurrentFolder: 'depotDocuments/deleteCurrentFolder',
      moveTheFile: 'depotDocuments/moveTheFile',
      shareFolder: 'depotDocuments/shareFolder',
      editRightsUser: 'depotDocuments/editRightsUsers',
      editRightsRoles: 'depotDocuments/editRightsRoles',
      removeShare: 'depotDocuments/removeShare',
      loadFiles: 'depotDocuments/loadFiles',
      addNewTempFile: 'depotDocuments/addNewTempFile',
      addNewFile: 'depotDocuments/addNewFile',
      downloadFolder: 'depotDocuments/downloadFolder',
      downloadFile: 'depotDocuments/downloadFile',
      editCurrentFile: 'depotDocuments/editCurrentFile',
    }),

    ...mapMutations({
      setMessageHeader: 'depotDocuments/SET_MESSAGEHEADER',
    }),

    openFolder(folder = null) {
      this.$emit('openFolder', folder == null ? {} : folder);
    },

    displayAllFiles() {
      this.$emit('displayAllFiles');
    },

    addButtonDisplaySomething() {
      if (this.isRootPage) {
        this.displayPopupAddNewFolder(true);
      }

      if (this.isCurrentFolderPage) {
        this.displayDropdownAddNewFolderOrFile();
      }

      if (this.isRecentFilesPage) {
        this.changeStatePopupAddNewFile(1);
      }
    },

    displayDropdownAddNewFolderOrFile() {
      this.isDropdownCreateFolderOrFileDisplay =
        !this.isDropdownCreateFolderOrFileDisplay;
    },

    displayPopupAddNewFolder(state) {
      this.isCreateFolderPopupDisplayed = state;
      this.errorsCreateNewFolder = {};
    },

    displayPopupEditFolder(state, folder = null) {
      if (folder) {
        this.folderToEdit = folder;
      }
      this.isEditFolderPopupDisplayed = state;
      this.errorsEditFolder = {};
    },

    displayPopupEditFile(state, file = null) {
      if (file) {
        this.fileToEdit = { ...file };
      }
      this.isEditFilePopupDisplayed = state;
      this.errorsEditFile = {};
    },

    displayPopupDeleteFolder(state, folder = null) {
      if (folder) {
        this.folderToDelete = folder;
      }
      this.isDeleteFolderPopupDisplayed = state;
      this.errorsDeleteFolder = {};
    },

    displayPopupMoveFile(state, file = null) {
      if (file) {
        this.fileToMove = file;
      }
      this.isMoveFilePopupDisplayed = state;
      this.errorsMoveFile = {};
    },

    displayPopupAddMember(state, folder = null) {
      if (folder) {
        this.folderToShare = folder;
      }
      this.isAddMemberPopupDisplayed = state;
      this.errorsAddMemberFolder = {};
    },

    displayPopupPreview(state, file = null) {
      if (file) {
        this.fileToDisplay = { ...file };
      }
      this.isPreviewPopupDisplayed = state;
    },

    changeStatePopupAddNewFile(state) {
      this.stateAddFilePopup = state;
      this.errorsAddNewFile = {};
      this.addNewFileLoading = false;
    },

    displaySubMenuFile(fileId) {
      this.subMenuFileNumber = fileId;
    },

    hideSubMenuFile() {
      this.subMenuFileNumber = -1;
    },

    async createFolder(folder) {
      try {
        await this.createNewFolder(folder).then((response) => {
          this.isCreateFolderPopupDisplayed = false;
          this.errorsCreateNewFolder = {};
        });
      } catch (err) {
        this.errorsCreateNewFolder = err;
      }
    },

    async editFolder(folder) {
      try {
        await this.editCurrentFolder([this.folderToEdit.id, folder]).then(
          (response) => {
            this.isEditFolderPopupDisplayed = false;
            this.errorsEditFolder = {};
            this.folderToEdit = {};
          }
        );
      } catch (err) {
        this.errorsEditFolder = err;
      }
    },

    async editFile(file) {
      try {
        console.log('filelist file', file);
        await this.editCurrentFile([this.fileToEdit.id, file]).then(
          (response) => {
            this.isEditFilePopupDisplayed = false;
            this.errorsEditFile = {};
            this.fileToEdit = {};
          }
        );
      } catch (err) {
        this.errorsEditFile = err;
      }
    },

    async deleteFolder() {
      try {
        await this.deleteCurrentFolder(this.folderToDelete).then((response) => {
          this.isDeleteFolderPopupDisplayed = false;
          this.folderToDelete = {};
        });
      } catch (err) {
        this.errorsDeleteFolder = err;
      }
    },

    async moveFile(file) {
      try {
        await this.moveTheFile({
          source: this.fileToMove,
          destination: file,
        }).then((response) => {
          this.isMoveFilePopupDisplayed = false;
          this.fileToMove = {};
        });
      } catch (err) {
        this.errorsMoveFile = err;
      }
    },

    async downloadAFolder(folder) {
      try {
        await this.downloadFolder(folder).then((response) => {
          JsFileDownload(response.data, folder.name + '.zip');
        });
      } catch (err) {
        //
      }
    },

    async downloadAFile(file) {
      try {
        await this.downloadFile(file).then((response) => {
          JsFileDownload(response.data, file.name);
        });
      } catch (err) {
        //
      }
    },

    async addMembers(members) {
      let responses = 200;
      if (members.users.length > 0 || members.roles.length > 0) {
        try {
          responses = 0;

          await this.shareFolder({
            folder: this.folderToShare,
            users: members.users,
            roles: members.roles,
          }).then((response) => {
            responses = response.status;
          });
        } catch (error) {
          console.error(error);
          this.errorsAddMemberFolder = error;
        }
      }

      if (responses == 200) {
        let successMessage =
          this.folderToShare.type == 'folder'
            ? 'Le dossier a été partagé avec succès.'
            : 'Le fichier a été partagé avec succès.';
        this.setMessageHeader({ type: 'success', msg: successMessage });
        setTimeout(() => {
          this.setMessageHeader(null);
        }, 3000);
        await this.loadFiles().then((response) => {
          this.updateFolderToShare();
        });
      }
    },

    async editUserRights(user, newRights) {
      try {
        await this.editRightsUser({
          users: [user],
          newRights: newRights,
          folder: this.folderToShare,
        }).then((response) => {
          this.updateFolderToShare();
        });
      } catch (error) {
        console.error(error);
        this.errorsAddMemberFolder = error;
      }
    },

    async editRoleRights(role, newRights) {
      try {
        await this.editRightsRoles({
          roles: [role],
          newRights: newRights,
          folder: this.folderToShare,
        }).then((response) => {
          this.updateFolderToShare();
        });
      } catch (error) {
        console.error(error);
        this.errorsAddMemberFolder = error;
      }
    },

    async revokeUserRights(user) {
      try {
        await this.removeShare({
          folder: this.folderToShare,
          users: [user],
          roles: [],
        }).then((response) => {
          this.updateFolderToShare();
        });
      } catch (error) {
        console.error(error);
        this.errorsAddMemberFolder = error;
      }
    },

    async revokeRoleRights(role) {
      try {
        await this.removeShare({
          folder: this.folderToShare,
          roles: [role],
          users: [],
        }).then((response) => {
          this.updateFolderToShare();
        });
      } catch (error) {
        console.error(error);
        this.errorsAddMemberFolder = error;
      }
    },

    updateFolderToShare() {
      this.folderToShare =
        this.folders.filter(
          (folder) => folder.id == this.folderToShare.id
        )[0] ||
        this.files.filter((file) => file.id == this.folderToShare.id)[0];
    },

    async addTempFile(data) {
      try {
        this.addNewFileLoading = true;
        await this.addNewTempFile(data).then((response) => {
          //the API returns the temporary path of the file
          this.fileTemp.path = response;
          this.fileTemp.finalPath = response.replace(
            'tmp/' + this.user.id + '/',
            ''
          );
          this.stateAddFilePopup = 2;
          this.addNewFileLoading = false;
        });
      } catch (err) {
        this.errorsAddNewFile = err;
        this.addNewFileLoading = false;
      }
    },

    async addFile(infos) {
      try {
        await this.addNewFile(infos).then((response) => {
          this.stateAddFilePopup = -1;
        });
      } catch (err) {
        this.errorsAddNewFile = err;
      }
    },

    goToPath(path = null) {
      this.$emit('goto', path);
    },
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),

    listIdsFolder: {
      get: function () {
        return this.folders.map((f) => f.id);
      },
    },

    rootFolders: {
      get: function () {
        return this.folders.filter(
          (f) =>
            f.folder_id == null || !this.listIdsFolder.includes(f.folder_id)
        );
      },
    },

    currentFolders: {
      get: function () {
        return this.folders.filter(
          (f) =>
            f.folder_id == this.path[this.path.length - 1].id ||
            (Object.keys(this.path[this.path.length - 1]).length == 0 &&
              (f.folder_id == null ||
                !this.listIdsFolder.includes(f.folder_id)))
        );
      },
    },

    currentFiles: {
      get: function () {
        return this.files.filter(
          (f) => f.folder_id == this.path[this.path.length - 1].id
        );
      },
    },

    parentFolder: {
      get: function () {
        return this.path.length > 0 ? this.path[this.path.length - 1].id : null;
      },
    },

    currentPage() {
      return this.$route.path;
    },

    canEdit() {
      let userId = this.currentPage.includes('/form/neopass/')
        ? parseInt(this.currentPage.split('/form/neopass/')[1].split('/')[0])
        : this.user.id;

      return (
        !this.currentPage.includes('/form/neopass/') ||
        this.$can('documents_edit', userId)
      );
    },

    isRootPage() {
      return (
        this.path.length == 0 &&
        (this.folders.length > 0 || this.files.length > 0)
      );
    },

    isCurrentFolderPage() {
      return this.path.length > 0 && this.path[0] !== 'allFiles';
    },

    isRecentFilesPage() {
      return this.path[0] == 'allFiles';
    },

    listFolders: {
      get: function () {
        if (this.isRootPage) {
          return this.rootFolders;
        }
        if (this.isCurrentFolderPage) {
          return this.currentFolders;
        }
        return [];
      },
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
